import KML from 'ol/format/KML.js';
import Map from 'ol/Map.js';
import Stamen from 'ol/source/Stamen.js';
import VectorSource from 'ol/source/Vector.js';
import View from 'ol/View.js';
import {Heatmap as HeatmapLayer,Vector as VectorLayer, Tile as TileLayer} from 'ol/layer.js';
import GeoJSON from 'ol/format/GeoJSON';
import {Icon, Style} from 'ol/style.js';
import {fromLonLat,toLonLat} from 'ol/proj';
import StadiaMaps from 'ol/source/StadiaMaps.js';

const blur = document.getElementById('blur');
const radius = document.getElementById('radius');

const nLLonLat = [5, 52];
const nLLonLatWebMercator = fromLonLat(nLLonLat);

const chineesfromjson = new HeatmapLayer({
  title: 'Restaurant',
  source: new VectorSource({
    url: 'https://geoserver.mijnlieff.nl/geoserver/dechinees/ows?service=WFS&version=1.0&request=GetFeature&typeName=dechinees_dev:restaurant&outputFormat=application/json',
    format: new GeoJSON(),
  }),
  blur: 15,
  radius: 12,
  weight: function (feature) {
   return 15;
 },
});


// const raster = new TileLayer({
//   source: new Stamen({
//     layer: 'toner',
//   }),
// });

const raster = new TileLayer({
  source: new StadiaMaps({
    //layer: 'stamen_watercolor',
    layer: 'stamen_toner',
    // apiKey: 'OPTIONAL'
  }),
});

new Map({
  layers: [raster,chineesfromjson],
  target: 'map',
  view: new View({
    center: nLLonLatWebMercator,
    zoom:8,
  }),
});

blur.addEventListener('input', function () {
  chineesfromjson.setBlur(parseInt(blur.value, 10));
});

radius.addEventListener('input', function () {
  chineesfromjson.setRadius(parseInt(radius.value, 10));
});
